__turbopack_context__.v({
  "className": "zA4O2W_className",
  "variable": "zA4O2W_variable",
});
